// ABOUTME: Estilos del modo foto para la página: mismo catálogo que la función (functions/styles.json).
import catalog from "../../functions/styles.json";

export interface PhotoStyle {
  id: string;
  name: string;
  kind: "full" | "crown" | "natural" | "wavy" | "waves";
  thumb: string;
}

export const PHOTO_STYLES: readonly PhotoStyle[] = (catalog as PhotoStyle[]).map(({ id, name, kind, thumb }) => ({ id, name, kind, thumb }));

import hairstyles from "../../functions/hairstyles.json";

export interface Hairstyle {
  id: string;
  name: string;
  thumb: string;
}

export const HAIRSTYLES: readonly Hairstyle[] = (hairstyles as Array<Hairstyle & { prompt: string; hidden?: boolean }>)
  .filter((h) => !h.hidden)
  .map(({ id, name, thumb }) => ({ id, name, thumb }));
